import { render } from "./MessageCrafter.vue?vue&type=template&id=53125eb8"
import script from "./MessageCrafter.vue?vue&type=script&lang=ts"
export * from "./MessageCrafter.vue?vue&type=script&lang=ts"
script.render = render

export default script